module.exports = __webpack_public_path__ + "img/imgrewardbtactive.6e5237a6.png";